import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetServiceRunsMapQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
  additionalFilters?: Types.InputMaybe<Array<Types.Mobility_Runs_Bool_Exp> | Types.Mobility_Runs_Bool_Exp>;
}>;


export type GetServiceRunsMapQuery = { __typename?: 'query_root', mobility_runs: Array<{ __typename?: 'mobility_runs', id: number, status: string, departure_time?: string | null, dispatched_at?: string | null, completed_at?: string | null, created_at: string, estimated_distance_miles?: number | null, config: object, driver?: { __typename?: 'drivers', id: number, status: string, user?: { __typename?: 'users', id: number, display_name: string, avatar_url?: string | null, phone?: string | null } | null } | null, vehicle?: { __typename?: 'mobility_vehicles', id: number, make: string, model: string, year?: number | null, license_plate?: string | null } | null, stops_aggregate: { __typename?: 'mobility_stops_aggregate', aggregate?: { __typename?: 'mobility_stops_aggregate_fields', count: number } | null }, stops: Array<{ __typename?: 'mobility_stops', id: number, stop_order: number, status: string, address?: string | null, address_lat?: number | null, address_lng?: number | null, location?: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null, geofence_radius?: number | null } | null, service_stop_detail: Array<{ __typename?: 'service_stop_details', customer_name?: string | null, estimated_service_minutes?: number | null, service_started_at?: string | null, service_completed_at?: string | null }> }> }> };


export const GetServiceRunsMapDocument = gql`
    query getServiceRunsMap($customerId: bigint!, $additionalFilters: [mobility_runs_bool_exp!]) {
  mobility_runs(
    where: {_and: [{customer_id: {_eq: $customerId}}, {product_type: {_eq: "mobile_service"}}, {_and: $additionalFilters}]}
    order_by: [{created_at: desc_nulls_last}]
    limit: 200
  ) {
    id
    status
    departure_time
    dispatched_at
    completed_at
    created_at
    estimated_distance_miles
    config
    driver {
      id
      status
      user {
        id
        display_name
        avatar_url
        phone
      }
    }
    vehicle {
      id
      make
      model
      year
      license_plate
    }
    stops_aggregate {
      aggregate {
        count
      }
    }
    stops(order_by: {stop_order: asc}) {
      id
      stop_order
      status
      address
      address_lat
      address_lng
      location {
        id
        name
        address
        latitude
        longitude
        geofence_radius
      }
      service_stop_detail {
        customer_name
        estimated_service_minutes
        service_started_at
        service_completed_at
      }
    }
  }
}
    `;

/**
 * __useGetServiceRunsMapQuery__
 *
 * To run a query within a React component, call `useGetServiceRunsMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceRunsMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceRunsMapQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      additionalFilters: // value for 'additionalFilters'
 *   },
 * });
 */
export function useGetServiceRunsMapQuery(baseOptions: Apollo.QueryHookOptions<GetServiceRunsMapQuery, GetServiceRunsMapQueryVariables> & ({ variables: GetServiceRunsMapQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceRunsMapQuery, GetServiceRunsMapQueryVariables>(GetServiceRunsMapDocument, options);
      }
export function useGetServiceRunsMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceRunsMapQuery, GetServiceRunsMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceRunsMapQuery, GetServiceRunsMapQueryVariables>(GetServiceRunsMapDocument, options);
        }
// @ts-ignore
export function useGetServiceRunsMapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceRunsMapQuery, GetServiceRunsMapQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceRunsMapQuery, GetServiceRunsMapQueryVariables>;
export function useGetServiceRunsMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceRunsMapQuery, GetServiceRunsMapQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceRunsMapQuery | undefined, GetServiceRunsMapQueryVariables>;
export function useGetServiceRunsMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceRunsMapQuery, GetServiceRunsMapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceRunsMapQuery, GetServiceRunsMapQueryVariables>(GetServiceRunsMapDocument, options);
        }
export type GetServiceRunsMapQueryHookResult = ReturnType<typeof useGetServiceRunsMapQuery>;
export type GetServiceRunsMapLazyQueryHookResult = ReturnType<typeof useGetServiceRunsMapLazyQuery>;
export type GetServiceRunsMapSuspenseQueryHookResult = ReturnType<typeof useGetServiceRunsMapSuspenseQuery>;
export type GetServiceRunsMapQueryResult = Apollo.QueryResult<GetServiceRunsMapQuery, GetServiceRunsMapQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/mobileService/queries/getServiceRunsMap.query.gql}
 */
export async function getServiceRunsMap(
  variables: GetServiceRunsMapQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetServiceRunsMapQuery['mobility_runs']>
export async function getServiceRunsMap(
  variables: GetServiceRunsMapQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetServiceRunsMapQuery>
export async function getServiceRunsMap(
  variables: GetServiceRunsMapQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetServiceRunsMapQuery['mobility_runs'] | GetServiceRunsMapQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetServiceRunsMapQuery>(
    GetServiceRunsMapDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.mobility_runs
}